import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';

// The inbox's filter, search and paging, plus the create link that opens in the
// shared dialog.
//
// No row actions: a lead is opened rather than acted on from the list. The
// decisions - qualifying, rejecting, merging - live on its own page, where the
// duplicate candidates and the raw submission are on screen to decide against.
export function initLeadList() {
  const live = initLiveList({
    results: 'lead-list',
    path: '/leads',
    // Both forms, merged into one query string by liveList - so a search keeps
    // the active filter and vice versa.
    forms: ['lead-filter', 'lead-search']
  });

  // Refetch rather than navigate after a save: the list behind the dialog is
  // already the right place to be, and a new lead belongs in it immediately.
  initFormModalLinks({
    selector: 'a[href$="/new"], a[href$="/edit"]',
    onSaved: () => live.refresh()
  });
}
